import PropTypes from 'prop-types'
import classNames from 'classnames'

import Icon from '../../icon'
import Typography from '../../typography'

import UserCircle from '../../../common/icon/user-circle-alt.svg'
import { getAuthor } from '../utils'

const ExtraDetails = ({ course, ...attrs }) => {
  const author = getAuthor(course)

  attrs.className = classNames(
    attrs.className,
    [
      'flex',
      'flex-row',
      'items-center'
    ]
  )
  return <div
    {...attrs}>
    <Icon
      className={'mr-2 text-yellow-500'}
      svg={UserCircle}
      width={48}
      height={48} />
    <div>
      <Typography
        size={'two'}
        weight={'bold'}>
        {
          author
            ? <>{author.firstName} {author.lastName}</>
            : 'El equipo Crehana'
        }
      </Typography>
      <Typography
        size={'three'}
        weight={'regular'}>
        {
          author
            ? <>{author.firstName} {author.lastName}</>
            : null
        }
      </Typography>
    </div>
  </div>
}

ExtraDetails.propTypes = {
  course: PropTypes.object
}

export default ExtraDetails
